import React from "react";

const PrivacyPolicy = () => {
  // Common style for section spacing
  const sectionStyle = { marginBottom: "30px" };
  const headerStyle = { marginBottom: "15px", textAlign: "left" };

  return (
    <div
      className="privacy-container"
      style={{
        padding: "60px 20px",
        maxWidth: "900px",
        margin: "0 auto",
        lineHeight: "1.8",
        color: "#333",
        textAlign: "left", // Ensures everything is left-aligned
        fontFamily: "sans-serif",
      }}
    >
      <header
        style={{
          marginBottom: "40px",
          borderBottom: "1px solid #eee",
          paddingBottom: "20px",
        }}
      >
        <h1 style={{ fontSize: "2.5rem", marginBottom: "10px" }}>
          Privacy Policy for Rental Highway
        </h1>
        <p style={{ color: "#666" }}>
          <strong>Last updated: May 09, 2025</strong>
        </p>
      </header>

      <div style={sectionStyle}>
        <p>
          This Privacy Policy describes Our policies and procedures on the
          collection, use and disclosure of Your information when You use the
          Service and tells You about Your privacy rights and how the law
          protects You.
        </p>
        <p>
          We use Your Personal Data to provide and improve the Service. By using
          the Service, You agree to the collection and use of information in
          accordance with this Privacy Policy.
        </p>
      </div>

      <hr
        style={{ margin: "40px 0", border: "0", borderTop: "1px solid #eee" }}
      />

      <section style={sectionStyle}>
        <h2 style={headerStyle}>1. Interpretation and Definitions</h2>
        <div style={{ paddingLeft: "10px" }}>
          <h3>Interpretation</h3>
          <p>
            The words with capitalized initial letters have meanings defined
            under the following conditions. These definitions shall have the
            same meaning regardless of whether they appear in singular or in
            plural.
          </p>
          <h3>Definitions</h3>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ marginBottom: "10px" }}>
              <strong>Account:</strong> A unique account created for You to
              access our Service.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Application:</strong> Refers to Rental Highway, the
              software provided by the Company.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Company:</strong> ("the Company", "We", "Us", or "Our")
              refers to Rental Highway.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Country:</strong> Any political region you are using the
              application. For example: Nepal, USA, Australia, etc.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Personal Data:</strong> Any information that relates to an
              identified or identifiable individual.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Service:</strong> Refers to the Application.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>You:</strong> The individual accessing or using the
              Service.
            </li>
          </ul>
        </div>
      </section>

      <section style={sectionStyle}>
        <h2 style={headerStyle}>2. Types of Data Collected</h2>
        <div style={{ paddingLeft: "10px" }}>
          <h3>Personal Data</h3>
          <p>We may collect personally identifiable information including:</p>
          <ul style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li>Email address</li>
            <li>First and last name</li>
            <li>Phone number</li>
            <li>Address (City, Province, Postal Code)</li>
            <li>Usage Data</li>
          </ul>

          <h3>Information Collected While Using the App</h3>
          <p>With your prior permission, we may access:</p>
          <ul style={{ paddingLeft: "20px" }}>
            <li>Your location</li>
            <li>Your device's contact list</li>
            <li>Camera or photo library</li>
          </ul>
        </div>
      </section>

      <section style={sectionStyle}>
        <h2 style={headerStyle}>3. Use of Your Personal Data</h2>
        <p>
          We may use Your data to provide and improve the Service, manage Your
          Account, and communicate with you regarding updates or promotions.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headerStyle}>4. Your Rights and Data Deletion</h2>
        <p>
          You have the right to access, update, or delete your Personal Data.
          You can request data deletion via your account settings or by
          contacting us directly.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headerStyle}>5. Children’s Privacy</h2>
        <p>
          Our Service is not intended for children under 13. We do not knowingly
          collect data from children.
        </p>
      </section>

      <section
        style={{
          ...sectionStyle,
          borderTop: "1px solid #eee",
          paddingTop: "20px",
        }}
      >
        <h2 style={headerStyle}>6. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy,
          contact us:
        </p>
        <p style={{ fontSize: "1.1rem" }}>
          Email:{" "}
          <a
            href="mailto:support@rentalhighway.com"
            style={{ color: "#007bff", textDecoration: "none" }}
          >
            support@rentalhighway.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
